import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { BPSAdminLevel, User } from '../models/user.model';
import { RegionService } from '../services/region.service';
import { AreaService } from '../services/area.service';
import { PermissionsEnum, Role, SystemComponents } from '../models/role.model';
import { RoleService } from '../services/role.service';
import { TranslationService } from 'src/app/services/translation.service';
import { PermissionsService, SubGeographicalRegionService, GeographicalRegionService, GeographicalRegion, CimSubstationService, VoltageClass } from 'shared-lib';
import { UserMgmTabs } from '../enums/user-mgm-tabs';
import { OrganizationTeamApiService } from '../services/organization-team-api.service';
import { Organization } from '../models/organization.model';
import { OrganizationStatus } from '../models/customer.model';
import { BillingAccountService } from '../services/billing-account.service';
import { DtService } from '../services/dt.service';
import { UtilityService } from '../services/utility.service';
import { UtilityDetails } from '../models/utility.model';
import { OrganizationAccess } from '../enums/organization-access.enum';

interface OptionObj {
  key: number;
  value: string;
}

interface MultiSelectItem {
  id: number;
  name: string;
  checked: boolean;
}

export interface Task {
  name: string;
  completed: boolean;
  subtasks?: Task[];
}

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
})
export class UserManagementComponent implements OnInit, OnDestroy {
  @ViewChild('closeModal') closeModal!: ElementRef;
  clicked: boolean = false;
  public searchValue: any;
  public cimSearchValue: any;
  selectedFilterRegionIds: number[] = [];
  selectedFilterAreaIds: number[] = [];
  public PermissionsEnum = PermissionsEnum;
  public currentPage: number = 1;
  public pageSize: number = 11;
  public searchText: string = '';
  public sysComponents = SystemComponents;
  public users: User[] | any = [];
  public userHistoryItems: any[] = [];

  public addNewUser: boolean = false;
  public showPw: boolean = false;
  public userId: number = 0;
  public name: string = '';
  public lastName: string = '';
  public email: string = '';
  public organizationId: number | null = null;
  public role: Role = new Role();
  public pass: string = '';
  public regionIds: number[] = [];
  public geographicalRegionIds: (number | null)[] | undefined = [];
  public subGeographicalRegionIds: (number | null)[] | undefined = [];
  public level: BPSAdminLevel;

  areaIds: number[] = [];

  regionOptions: OptionObj[] = [];
  areaOptions: OptionObj[] = [];
  regionMultiSelectOptions: MultiSelectItem[] = [];
  areaMultiSelectOptions: MultiSelectItem[] = [];

  geographicalRegionMultiSelectOptions: MultiSelectItem[] = [];
  subGeographicalRegionMultiSelectOptions: MultiSelectItem[] = [];
  selectedFilterGeographicalRegionIds: number[] = [];
  selectedFilterSubGeographicalIds: number[] = [];
  roleOptions: Role[] = [];
  levelOptions = [
    {
      name: 'Level 1 (Full Control)',
      value: BPSAdminLevel.Level1,
      stringValue: 'Level1',
    },
    {
      name: 'Level 2 (Read Only)',
      value: BPSAdminLevel.Level2,
      stringValue: 'Level2',
    },
  ];

  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');

  organizationForSelect: any;

  filterByOptions = OrganizationStatus;
  showFilterByStatus: boolean = false;
  showFilterByOrganization: boolean = false;

  mapStatus: Record<number, string> = {
    [OrganizationStatus.All]: 'COMMON.FILTER_BY_OPTIONS.ALL',
    [OrganizationStatus.Active]: 'COMMON.FILTER_BY_OPTIONS.ACTIVE',
    [OrganizationStatus.Inactive]: 'COMMON.FILTER_BY_OPTIONS.INACTIVE',
  };

  filterByValue: OrganizationStatus = OrganizationStatus.All;
  filterByOrganizationId: any = -1;
  filterByRoles: number[] = [];

  filterByStatusName: string = this.mapStatus[OrganizationStatus.All];
  filterByOrganizationName: string;

  task: Task = {
    name: 'Indeterminate',
    completed: false,
    subtasks: [
      { name: 'Primary', completed: false },
      { name: 'Accent', completed: false },
      { name: 'Warn', completed: false },
    ],
  };
  allComplete: boolean = false;
  isBpsAdmin: boolean = false;
  showUpload: boolean = false;
  utilityId: number = 0;
  bpsAdminLevel: BPSAdminLevel;

  currentTab: number = UserMgmTabs.UserManagementTab;
  reset: boolean = false;

  countUserMgm = 0;
  countOrgTeam = 0;
  tabs = UserMgmTabs;

  organizationTeams: Organization[] | any = [];
  newOrgTeamName: string = '';
  newOrgTeamId: string = '';
  blockOptions: string[] = [];
  plotOptions: string[] = [];
  roundOptions: string[] = [];
  dtOptions: any = [];
  filteredDts: any
  selectedBlocks: string[] = [];
  selectedPlots: string[] = [];
  selectedRounds: string[]
  utility: UtilityDetails;
  selectedDtIds: number[] = [];
  selectedCimDtIds: number[] = [];
  cimDtOptions: any = [];
  filteredCimDts: any
  organizationAccessOptions = Object.keys(OrganizationAccess)
    .filter(k => isNaN(Number(k)))
    .map(key => ({
      label: `ROLE_MANAGEMENT.ORGANIZATION_TEAM.OPERATION_ACCESS_LEVEL.ENUM.${key.toUpperCase()}`,
      value: OrganizationAccess[key as keyof typeof OrganizationAccess]
    }));
  geographicalRegionOptions: GeographicalRegion[] | undefined = [];
  subGeographicalRegionOptions: any[] = [];
  selectedOperationAccessLevel: number = -1;
  paymentHubVendorId: number | null = null;
  isEdit: boolean = false;
  id: number | null = null;

  constructor(
    private userService: UserService,
    private organizationTeamService: OrganizationTeamApiService,
    private toastr: ToastrService,
    private regionService: RegionService,
    private areaService: AreaService,
    private translationService: TranslationService,
    public permissionsService: PermissionsService,
    private roleService: RoleService,
    private changeDetectorRef: ChangeDetectorRef,
    private billingAccountService: BillingAccountService,
    private dtService: DtService,
    private utilityService: UtilityService,
    private subGeographicalRegionService: SubGeographicalRegionService,
    private geographicalRegionService: GeographicalRegionService,
    private cimSubstationService: CimSubstationService
  ) { }

  ngOnInit() {
    this.getOrganizationForSelect();
    this.filterByOrganizationType(-1);
    if (!this.permissionsService.hasUtility) {
      this.isBpsAdmin = true;
      this.bpsAdminLevel = parseInt(
        localStorage.getItem('bpsAdminLevel') || '0'
      );
    } else {
      this.getRegionsForOptions();
      this.getGeographicalRegionsForOptions();
      this.getRoles();
    }
    this.utilityId = parseInt(localStorage.getItem('utilityId') || '');
    if (!this.isBpsAdmin) {
      this.getAllTabsCount();
      this.getUtility();
    }
  }

  private getUtility() {
    this.utilityService.get(this.utilityId).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData.status === 'OK' || responseData.status === '200') {
          this.utility = responseData.data;
        }
      },
      error: (error: any) => {
        this.toastr.error(error.message || 'An error occurred while fetching utility data.');
      }
    });
  }

  private syncAreasWithRegions() {
    if (!this.regionIds || this.regionIds.length === 0) {
      this.areaOptions = [];
      this.areaIds = [];
      return;
    }
    this.areaService.getAreasForOptionsByRegionIds(this.regionIds).subscribe(
      (response) => {
        this.areaOptions = response.body.data;
        const validAreaIds = (this.areaOptions || []).map((item: any) => item.key);
        this.areaIds = (this.areaIds || []).filter((id) => validAreaIds.includes(id));
        this.changeDetectorRef.detectChanges();
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }
  private syncSubGeographicalRegionsWithGeographicalRegions() {
    if (!this.geographicalRegionIds || this.geographicalRegionIds.length === 0) {
      this.subGeographicalRegionOptions = [];
      this.subGeographicalRegionIds = [];
      return;
    }
    this.subGeographicalRegionService.getByGeographicalRegionIds(this.geographicalRegionIds).subscribe(
      (response: { body: { data: any[]; }; }) => {
        this.subGeographicalRegionOptions = response.body.data;
        const validAreaIds = (this.subGeographicalRegionOptions || []).map((item: any) => item.id);
        this.subGeographicalRegionIds = (this.subGeographicalRegionIds || []).filter((id) => validAreaIds.includes(id));
        this.changeDetectorRef.detectChanges();
      },
      () => {
        this.toastr.error('An error occurred.');
      }
    );
  }
  getRegionsForOptions() {
    this.regionService.getRegionsForOptions().subscribe(
      (response) => {
        this.regionOptions = response.data;
        this.regionMultiSelectOptions = this.regionOptions.map((option) => ({
          id: option.key,
          name: option.value,
          checked: false,
        }));
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }
  getGeographicalRegionsForOptions() {
    this.geographicalRegionService.getAllForSelect().subscribe(
      (response) => {
        this.geographicalRegionOptions = response?.body?.data;
        this.geographicalRegionMultiSelectOptions = (this.geographicalRegionOptions ?? []).map((option) => ({
          id: option.id!,
          name: option.name,
          checked: false,
        }));
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }
  getDtsForOptions() {
    this.dtService.getDtsForSelectByAreaIds(this.areaIds).subscribe(
      (response) => {

        this.dtOptions = response.body.data;
        this.filteredDts = response.body.data;
        const validIds = (this.dtOptions || []).map((x: any) => x.key);
        this.selectedDtIds = (this.selectedDtIds || []).filter((id) =>
          validIds.includes(id)
        );
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }
  getCimDtsForOptions() {
    this.cimSubstationService
      .getFilteredBySubGeographical({ subGeographicalRegionIds: this.subGeographicalRegionIds, voltageClasses: [VoltageClass.LV] })
      .subscribe((response) => {
        this.cimDtOptions = response.body.data;
        this.filteredCimDts = response.body.data;
        const validIds = (this.cimDtOptions || []).map((x: any) => x.id);
        this.selectedCimDtIds = (this.selectedCimDtIds || []).filter((id) =>
          validIds.includes(id)
        );
      },
        () => {
          this.toastr.error('An error occurred.');
        })
  }
  selectFilterRegion(event: any) {
    const { checked, id } = event;
    const region = this.regionMultiSelectOptions.find((item) => item.id === id);
    if (region) {
      region.checked = checked;
    }
    this.selectedFilterRegionIds = this.regionMultiSelectOptions
      .filter((item) => item.checked)
      .map((item) => item.id);
    this.selectedFilterAreaIds = [];
    this.areaMultiSelectOptions = [];
    if (this.selectedFilterRegionIds.length > 0) {
      this.areaService
        .getAreasForOptionsByRegionIds(this.selectedFilterRegionIds)
        .subscribe(
          (response) => {
            this.areaOptions = response.body.data;
            this.areaMultiSelectOptions = this.areaOptions.map((option) => ({
              id: option.key,
              name: option.value,
              checked: false,
            }));
            this.changeDetectorRef.detectChanges();
          },
          (error) => {
            this.toastr.error('An error occurred while fetching areas.');
          }
        );
    }
  }
  selectFilterGeographicalRegion(event: any) {
    const { checked, id } = event;
    const region = this.geographicalRegionMultiSelectOptions.find((item) => item.id === id);
    if (region) {
      region.checked = checked;
    }
    this.selectedFilterGeographicalRegionIds = this.geographicalRegionMultiSelectOptions
      .filter((item) => item.checked)
      .map((item) => item.id);
    this.selectedFilterSubGeographicalIds = [];
    this.subGeographicalRegionMultiSelectOptions = [];
    if (this.selectedFilterGeographicalRegionIds.length > 0) {
      this.subGeographicalRegionService
        .getByGeographicalRegionIds(this.selectedFilterGeographicalRegionIds)
        .subscribe(
          (response) => {
            this.subGeographicalRegionOptions = response.body.data;
            this.subGeographicalRegionMultiSelectOptions = this.subGeographicalRegionOptions.map((option) => ({
              id: option.id,
              name: option.name,
              checked: false,
            }));
            this.changeDetectorRef.detectChanges();
          },
          (error) => {
            this.toastr.error('An error occurred while fetching areas.');
          }
        );
    }
  }
  selectFilterArea(event: any) {
    const { checked, id } = event;
    const area = this.areaMultiSelectOptions.find((item) => item.id === id);
    if (area) {
      area.checked = checked;
    }
    this.selectedFilterAreaIds = this.areaMultiSelectOptions
      .filter((item) => item.checked)
      .map((item) => item.id);
  }
  selectFilterSubGeographicalIds(event: any) {
    const { checked, id } = event;
    const area = this.subGeographicalRegionMultiSelectOptions.find((item) => item.id === id);
    if (area) {
      area.checked = checked;
    }
    this.selectedFilterSubGeographicalIds = this.subGeographicalRegionMultiSelectOptions
      .filter((item) => item.checked)
      .map((item) => item.id);
  }
  applyFilter() {
    this.reloadTable();
  }

  reloadTable(searchText?: string, page: any = null) {
    if (page) {
      this.currentPage = page;
    }

    let dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: {
        searchParam: searchText,
        status: this.filterByValue,
        organizationId: this.filterByOrganizationId,
        roleIds: this.filterByRoles,
        regionIds: this.selectedFilterRegionIds,
        selectedAreas: this.selectedFilterAreaIds,
        selectedSubGeographicalRegions : this.selectedFilterSubGeographicalIds
      },
    };

    if (this.currentTab === UserMgmTabs.UserManagementTab) {
      this.userService.getAll(dataIn).subscribe({
        next: (response) => {
          this.users = response.data.data;
          this.countUserMgm = response.data.count ?? 0;
          if (this.countUserMgm === 0) {
            this.toastr.info('No data for given input.');
          }
        },
        error: (_) => this.toastr.error('Error occurred'),
      });
      this.getOrganizationForSelect();
    } else {
      this.organizationTeamService.getAll(dataIn).subscribe({
        next: (response) => {
          this.organizationTeams = response.data.data;
          this.countOrgTeam = response.data.count ?? 0;
          if (this.countOrgTeam === 0) {
            this.toastr.info('No data for given input.');
          }
        },
        error: (_) => this.toastr.error('Error occurred'),
      });
    }
  }

  filterByStatusType(option: OrganizationStatus) {
    this.filterByValue = option;
    this.filterByStatusName = this.mapStatus[option];
    this.currentPage = 1;
    this.reloadTable();
  }

  filterByOrganizationType(organization: any) {
    if (organization == -1) {
      this.filterByOrganizationName = 'COMMON.FILTER_BY_OPTIONS.ALL';
      this.filterByOrganizationId = organization;
    } else {
      this.filterByOrganizationId = organization.id;
      this.filterByOrganizationName = organization.name;
    }
    this.reloadTable();
  }

  changeTab(page: number) {
    this.getAllTabsCount();
    this.filterByValue = OrganizationStatus.All;
    this.filterByStatusName = this.mapStatus[OrganizationStatus.All];
    this.currentPage = 1;
    this.currentTab = page;
    this.searchText = '';
    this.reloadTable();
  }

  getOrganizationForSelect() {
    this.organizationTeamService.getAllForSelect().subscribe(
      (response) => {
        this.organizationForSelect = response.data;
      },
      () => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  getRoles() {
    this.roleService.getAll(false).subscribe(
      (response) => {
        this.roleOptions = response.body?.data;
      },
      () => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  getBlocks() {
    var obj = {
      areaIds: this.areaIds,
    };
    this.billingAccountService.getBlocks(obj).subscribe(
      (response) => {
        this.blockOptions = response.body?.data;
      },
      () => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  getRounds() {
    var obj = {
      areaIds: this.areaIds,
      blocks: this.selectedBlocks,
    };
    this.billingAccountService.getRounds(obj).subscribe(
      (response) => {
        this.roundOptions = response.body?.data;
      },
      () => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  getPlots() {
    var obj = {
      areaIds: this.areaIds,
      blocks: this.selectedBlocks,
      rounds: this.selectedRounds,
    };
    this.billingAccountService.getPlots(obj).subscribe(
      (response) => {
        this.plotOptions = response.body?.data;
      },
      () => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  updateAllComplete() {
    this.allComplete =
      this.task.subtasks != null &&
      this.task.subtasks.every((t) => t.completed);
  }

  someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return (
      this.task.subtasks.filter((t) => t.completed).length > 0 &&
      !this.allComplete
    );
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.task.subtasks == null) {
      return;
    }
    this.task.subtasks.forEach((t) => (t.completed = completed));
  }

  ngOnDestroy() { }

  selectAddOrganization(e: any) {
    if (e.target.value == 'Select Organization') this.organizationId = null;
    else this.organizationId = parseInt(e.target.value);
  }

  selectOption(e: any) {
    this.areaIds = [];
    this.regionIds = [];
    this.areaOptions = [];
    let tempRole = this.roleOptions.find(
      (option) => option.id == e.target.value
    );
    if (tempRole != null) this.role = tempRole;
  }

  selectLevelOption(e: any) {
    this.areaIds = [];
    this.regionIds = [];
    this.areaOptions = [];
    let tempRole = this.levelOptions.find(
      (option) => option.value == e.target.value
    );
    if (tempRole != null) this.level = tempRole.value;
  }

  selectRegion(e: any) {
    if (e.target.value != null) {
      this.regionIds.push(+e.target.value);
      this.areaIds = [];
      this.clicked = true;
    }
    this.syncAreasWithRegions();
  }
  selectGeographicalRegion(e: any) {
    if (e.target.value != null) {
      this.geographicalRegionIds?.push(+e.target.value);
      this.subGeographicalRegionIds = [];
      this.clicked = true;
    }
    this.syncSubGeographicalRegionsWithGeographicalRegions();
  }
  handleClick(id: number, e: any) {
    const isChecked = (e.target as HTMLInputElement).checked;
    let ids = this.areaIds.filter((x) => x == id);
    let maxSelectedDistricts = 2;
    if (this.utility.maximumSelectedAreasForMobile != null &&
      this.role.systemComponent == this.sysComponents.Mobile &&
      this.utility.isSelectedAreasForMobileLimited) {
      maxSelectedDistricts = this.utility.maximumSelectedAreasForMobile;
    }

    if (ids.length == 0) {
      if (
        this.areaIds.length >= maxSelectedDistricts &&
        this.role.systemComponent == this.sysComponents.Mobile &&
        (this.utility.isSelectedAreasForMobileLimited === true ||
          this.utility.isSelectedAreasForMobileLimited === null ||
          this.utility.isSelectedAreasForMobileLimited === undefined
        )
      ) {
        this.toastr.info(
          `A field operator can only be assigned to a maximum of ${maxSelectedDistricts} districts.`
        );
        (e.target as HTMLInputElement).checked = false;
      } else {
        this.areaIds.push(id);        
        if (
          this.role.permissions.includes(
            PermissionsEnum.MeterReading
          )
        ) {
          this.getBlocks();
        }
        this.getDtsForOptions();
      }
    } else if (!isChecked) {
      this.areaIds.splice(this.areaIds.indexOf(id), 1);
      this.getDtsForOptions();
    }
    this.changeDetectorRef.detectChanges();
  }


  handleCimClick(id: number, e: any) {
    const isChecked = (e.target as HTMLInputElement).checked;
    let ids = this.subGeographicalRegionIds!.filter((x) => x == id);
    let maxSelectedDistricts = 2;
    if (this.utility.maximumSelectedAreasForMobile != null &&
      this.role.systemComponent == this.sysComponents.Mobile &&
      this.utility.isSelectedAreasForMobileLimited) {
      maxSelectedDistricts = this.utility.maximumSelectedAreasForMobile;
    }

    if (ids.length == 0) {
      if (
        this.subGeographicalRegionIds!.length >= maxSelectedDistricts &&
        this.role.systemComponent == this.sysComponents.Mobile &&
        (this.utility.isSelectedAreasForMobileLimited === true ||
          this.utility.isSelectedAreasForMobileLimited === null ||
          this.utility.isSelectedAreasForMobileLimited === undefined
        )
      ) {
        this.toastr.info(
          `A field operator can only be assigned to a maximum of ${maxSelectedDistricts} districts.`
        );
        (e.target as HTMLInputElement).checked = false;
      } else {
        this.subGeographicalRegionIds!.push(id);
        // if (
        //   this.role.permissions.includes(
        //     PermissionsEnum.MeterReading
        //   )
        // ) {
        //   this.getBlocks();
        // }
        this.getCimDtsForOptions();
      }
    } else if (!isChecked) {
      this.subGeographicalRegionIds!.splice(this.subGeographicalRegionIds!.indexOf(id), 1);
      this.getCimDtsForOptions();
    }
    this.changeDetectorRef.detectChanges();
  }

  handleClickBlocks(block: string, e: any) {
    const isChecked = (e.target as HTMLInputElement).checked;
    let blocks = this.selectedBlocks.filter((x) => x == block);
    if (blocks.length == 0) {
      if (this.selectedBlocks.length >= 1) {
        this.toastr.info(
          'A meter reader can only be assigned to a maximum of one block.'
        );
        (e.target as HTMLInputElement).checked = false;
      } else {
        this.selectedBlocks.push(block);
        this.getRounds();
      }
    } else if (!isChecked)
      this.selectedBlocks.splice(this.selectedBlocks.indexOf(block), 1);
    this.changeDetectorRef.detectChanges();
  }

  handleClickRounds(round: string, e: any) {
    const isChecked = (e.target as HTMLInputElement).checked;
    let rounds = this.selectedRounds.filter((x) => x == round);
    if (rounds.length == 0) {
      this.selectedRounds.push(round);
      this.getPlots();
    } else if (!isChecked)
      this.selectedRounds.splice(this.selectedRounds.indexOf(round), 1);
    this.changeDetectorRef.detectChanges();
  }
  handleClickDt(id: number, e: any) {
    const isChecked = (e.target as HTMLInputElement).checked;
    let dtIds = this.selectedDtIds.filter((x) => x == id);
    if (dtIds.length == 0) {
      this.selectedDtIds.push(id);
    } else if (!isChecked)
      this.selectedDtIds.splice(this.selectedDtIds.indexOf(id), 1);
    this.changeDetectorRef.detectChanges();
  }
  handleClickCimDt(id: number, e: any) {
    const isChecked = (e.target as HTMLInputElement).checked;
    let dtIds = this.selectedCimDtIds.filter((x) => x == id);
    if (dtIds.length == 0) {
      this.selectedCimDtIds.push(id);
    } else if (!isChecked)
      this.selectedCimDtIds.splice(this.selectedCimDtIds.indexOf(id), 1);
    this.changeDetectorRef.detectChanges();
  }
  handleClickPlots(plot: string, e: any) {
    const isChecked = (e.target as HTMLInputElement).checked;
    let plots = this.selectedPlots.filter((x) => x == plot);
    if (plots.length == 0) {
      this.selectedPlots.push(plot);
    } else if (!isChecked)
      this.selectedPlots.splice(this.selectedPlots.indexOf(plot), 1);
    this.changeDetectorRef.detectChanges();
  }
  handleCheckDt(dt: any) {
    return this.selectedDtIds.includes(dt);
  }
  handleCheckCimDt(dt: any) {
    return this.selectedCimDtIds.includes(dt);
  }
  handleCheckBlocks(block: string) {
    return this.selectedBlocks.includes(block);
  }

  handleCheckPlots(plot: string) {
    return this.selectedPlots.includes(plot);
  }

  handleCheckRounds(round: string) {
    return this.selectedRounds.includes(round);
  }

  handleCheck(id: number) {
    return this.areaIds.includes(id);
  }
  handleCimCheck(id: number) {
    return this.subGeographicalRegionIds?.includes(id);
  }

  isDisabled(id: number): boolean {
    return this.areaIds.includes(id);
  }

  onSearch() {
    this.currentPage = 1;
    this.reloadTable(this.searchText);
  }

  viewHistory(userId: number) {
    const timezoneValue = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.userService.getUserHistory(userId, timezoneValue).subscribe({
      next: (response) => {
        this.userHistoryItems = response?.body?.data ?? [];
      },
      error: (_) => this.toastr.error('Error occurred'),
    });
  }

  onEdit(user: any) {
    if (this.isBpsAdmin && this.bpsAdminLevel == BPSAdminLevel.Level2) {
      return;
    }
    this.getById(user.id);
    this.userId = user.id;
    this.name = user.firstName;
    this.lastName = user.lastName;
    this.organizationId = user.organizationId;
    this.email = user.email;
    this.addNewUser = true;
    let tempRole = this.roleOptions.find((option) => option.id == user.role.id);
    if (tempRole != null) this.role = tempRole;

    let tempLevel = this.levelOptions.find(
      (option) => option.stringValue == user.level
    );
    if (tempLevel != null) this.level = tempLevel.value;
  }

  getById(id: number) {
    this.plotOptions = [];
    this.blockOptions = [];
    this.roundOptions = [];
    this.dtOptions = [];
    this.userService.getById(id, true).subscribe(
      (data) => {
        this.areaIds = data.data.areaIds;
        this.regionIds = data.data.regionIds ?? [];
        this.selectedBlocks = data.data.blocks;
        this.selectedPlots = data.data.plots;
        this.selectedRounds = data.data.rounds;
        this.selectedDtIds = data.data.selectedDtIds ?? [];
        this.geographicalRegionIds = data.data.geographicalRegionIds ?? [];
        this.selectedCimDtIds = data.data.selectedCimDtIds ?? [];
        this.subGeographicalRegionIds = data.data.subGeographicalRegionIds ?? [];
        this.areaService
          .getAreasForOptionsByRegionIds(this.regionIds)
          .subscribe(
            (response) => {
              this.areaOptions = response.body.data;
            },
            () => {
              this.toastr.error('An error occurred.');
            }
          );
        this.subGeographicalRegionService.getByGeographicalRegionIds(this.geographicalRegionIds).subscribe(
          (response) => {
            this.subGeographicalRegionOptions = response.body.data;
          },
          () => {
            this.toastr.error('An error occurred.');
          }
        );
        this.getDtsForOptions();
        this.getCimDtsForOptions();
        if (this.selectedPlots != null && this.selectedPlots.length > 0)
          this.getPlots();
        if (this.selectedBlocks != null && this.selectedBlocks.length > 0)
          this.getBlocks();
        if (this.selectedRounds != null && this.selectedRounds.length > 0)
          this.getRounds();
      },
      () => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  onSetStatus(id: number, status: string, isDisabled: boolean) {
    if (this.isBpsAdmin && this.bpsAdminLevel == BPSAdminLevel.Level2) {
      return;
    }
    if (status == null) {
      this.toastr.warning(
        'User does not have valid status. Please contact support.'
      );
      return;
    }
    if (!isDisabled) {
      let newStatus = '';
      if (status.toLowerCase() === 'active') {
        newStatus = 'Inactive';
      } else {
        newStatus = 'Active';
      }
      let obj = {
        id: id,
        status: newStatus,
      };

      this.userService.setStatus(obj).subscribe(
        (x) => {
          if (x.status === '200' || x.status === 'OK') {
            this.toastr.success('Status changed successfully.');
            this.reloadTable();
          } else this.toastr.error(x.message);
        },
        (error) => {
          this.toastr.error('An error occurred.');
        }
      );
    } else
      this.toastr.info("You can't activate/deactivate user with this role");
  }

  selectOrganization(team: any) {
    this.filterByOrganizationId = team.id;
    this.filterByOrganizationName = team.name;
    this.changeTab(UserMgmTabs.UserManagementTab);
  }

  selectRole(e: any) {
    this.filterByRoles = this.roleOptions
      .filter((x) => x.checked)
      .map((x) => x.id);
  }

  onAddNewUser() {
    if (this.permissionsService.isUserManagementCreateEditAllowed)
      this.addNewUser = true;
    else this.toastr.error("You don't have permission");
  }

  onCancel() {
    this.addNewUser = false;
    this.initialState();
  }

  showPassword() {
    this.showPw = !this.showPw;
  }

  selectAllDts() {
    this.selectedDtIds = [];
    this.filteredDts.forEach((x: any) => {
      this.selectedDtIds.push(x.key);
    });
    this.changeDetectorRef.detectChanges();
  }
  selectAllCimDts() {
    this.selectedCimDtIds = [];
    this.filteredCimDts.forEach((x: any) => {
      this.selectedCimDtIds.push(x.id);
    });
    this.changeDetectorRef.detectChanges();
  }

  deselectAllDts() {
    this.selectedDtIds = [];
    this.changeDetectorRef.detectChanges();
  }
  deselectAllCimDts() {
    this.selectedCimDtIds = [];
    this.changeDetectorRef.detectChanges();
  }
  handleFormSubmit() {
    const shouldValidatePassword =
      this.userId === 0 || (this.userId !== 0 && this.pass?.length > 0);

    if (shouldValidatePassword) {
      if (this.pass?.length < 10) {
        this.toastr.error('Password must be at least 10 characters');
        return;
      }
      if (this.pass?.search(/[a-z]/i) < 0) {
        this.toastr.error('Password must contain at least one letter.');
        return;
      }
      if (this.pass?.search(/[0-9]/) < 0) {
        this.toastr.error('Password must contain at least one digit.');
        return;
      }
      if (this.pass?.search(/[$&+,:;=?@#|'<>.^*()%!-]/) < 0) {
        this.toastr.error(
          "Password must contain at least one special character ($&+,:;=?@#|'<>.^*()%!-)."
        );
        return;
      }
      if (this.pass.toLowerCase().includes(this.email.toLowerCase())) {
        this.toastr.error('Password must not contain user email.');
        return;
      }
    }
    if (/^[0-9]+$/.test(this.name) || /^[0-9]+$/.test(this.lastName)) {
      this.toastr.error('Names cannot be only numbers.');
      return;
    }

    if (this.email?.search(/[@]/) < 0) {
      this.toastr.error('Invalid Email format.');
      return;
    }
    if (this.email?.search(/[.]/) < 0) {
      this.toastr.error('Invalid Email format.');
      return;
    }

    if (!this.isBpsAdmin && this.areaIds.length == 0 && !this.permissionsService.hasDashboardConfigCIMDataIntegration) {
      this.toastr.error('Please select at least one area.');
      return;
    }
    if (!this.isBpsAdmin && this.subGeographicalRegionIds!.length == 0 && this.permissionsService.hasDashboardConfigCIMDataIntegration) {
      this.toastr.error('Please select at least one area.');
      return;
    }
    if (this.isBpsAdmin && this.level == null) {
      this.toastr.error('Please select BPS admin level!');
      return;
    }
    if (
      !this.isBpsAdmin &&

      this.role.systemComponent == SystemComponents.Mobile &&
      (this.role.permissions.includes(PermissionsEnum.Meter_Validation_View) || this.role.permissions.includes(PermissionsEnum.Meter_Validation_CreateEdit))
    ) {
      if (this.selectedDtIds.length == 0 && !this.permissionsService.hasDashboardConfigCIMDataIntegration) {
        this.toastr.error('Please select at least one DT.');
        return;
      }
      if (this.selectedCimDtIds.length == 0 && this.permissionsService.hasDashboardConfigCIMDataIntegration) {
        this.toastr.error('Please select at least one DT.');
        return;
      }
    }

    let maxSelectedDistricts = 2;
    if (!this.isBpsAdmin && (this.utility.isSelectedAreasForMobileLimited ||
      this.utility.isSelectedAreasForMobileLimited === null ||
      this.utility.isSelectedAreasForMobileLimited === undefined) &&
      this.role.systemComponent == SystemComponents.Mobile) {
      if (this.utility.maximumSelectedAreasForMobile)
        maxSelectedDistricts = this.utility.maximumSelectedAreasForMobile;
      if (this.areaIds.length > maxSelectedDistricts && !this.permissionsService.hasDashboardConfigCIMDataIntegration) {
        this.toastr.error(
          `A field operator can only be assigned to a maximum of ${maxSelectedDistricts} districts.`
        );
        return;
      }
      if (this.subGeographicalRegionIds!.length > maxSelectedDistricts && this.permissionsService.hasDashboardConfigCIMDataIntegration) {
        this.toastr.error(
          `A field operator can only be assigned to a maximum of ${maxSelectedDistricts} districts.`
        );
        return;
      }
    }

    let obj = {
      organizationId: this.organizationId,
      id: this.userId,
      firstName: this.name,
      lastName: this.lastName,
      email: this.email.replace(/\s/g, '').trim(),
      password: this.pass,
      role: this.isBpsAdmin ? null : this.role.id,
      status: 'Active',
      areaIds: this.areaIds,
      level: this.level,
      blocks: this.selectedBlocks,
      plots: this.selectedPlots,
      rounds: this.selectedRounds,
      selectedDtIds: this.selectedDtIds,
      selectedSubGeographicalRegions: this.subGeographicalRegionIds,
      selectedCimSubstationIds: this.selectedCimDtIds
    };

    this.userService.saveUser(obj).subscribe(
      (x) => {
        if (x.status === '200' || x.status === 'OK') {
          this.toastr.success('User saved successfully');
          this.addNewUser = false;
          this.reloadTable();
          this.initialState();
        } else this.toastr.error(x.message);
      },
      () => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  checkAllCheckBox(e: any) {
    if (this.currentTab === UserMgmTabs.UserManagementTab) {
      this.users.forEach(
        (product: any) => (product.checked = e.target.checked)
      );
    } else {
      this.organizationTeams.forEach(
        (product: any) => (product.checked = e.target.checked)
      );
    }
  }

  isAllCheckBoxChecked() {
    if (this.currentTab === UserMgmTabs.UserManagementTab) {
      return this.users.every((p: any) => p.checked);
    } else {
      return this.organizationTeams.every((p: any) => p.checked);
    }
  }

  pageChange(value: any) {
    this.currentPage = value;
    this.reloadTable(this.searchText);
  }

  initialState() {
    this.userId = 0;
    this.name = '';
    this.lastName = '';
    this.email = '';
    this.role = new Role();
    this.pass = '';
    this.geographicalRegionIds = [];
    this.subGeographicalRegionIds = [];
  }

  selectAllAreas(e: any) {
    let maxSelectedDistricts = 2;
    if (this.utility.maximumSelectedAreasForMobile != null && this.role.systemComponent == SystemComponents.Mobile && this.utility.isSelectedAreasForMobileLimited)
      maxSelectedDistricts = this.utility.maximumSelectedAreasForMobile;

    if (
      this.areaOptions.length > maxSelectedDistricts &&
      this.role.systemComponent == SystemComponents.Mobile &&
      (this.utility.isSelectedAreasForMobileLimited === true ||
        this.utility.isSelectedAreasForMobileLimited === null ||
        this.utility.isSelectedAreasForMobileLimited === undefined
      )
    ) {
      this.toastr.info(
        `A field operator can only be assigned to a maximum of ${maxSelectedDistricts} districts.`
      );
      (e.target as HTMLInputElement).checked = false;
    } else {
      this.areaIds = this.areaOptions.map(function (a) {
        return a.key;
      });
    }
  }
  selectAllSubGeographicalRegions(e: any) {
    let maxSelectedDistricts = 2;
    if (this.utility.maximumSelectedAreasForMobile != null && this.role.systemComponent == SystemComponents.Mobile && this.utility.isSelectedAreasForMobileLimited)
      maxSelectedDistricts = this.utility.maximumSelectedAreasForMobile;

    if (
      this.subGeographicalRegionOptions.length > maxSelectedDistricts &&
      this.role.systemComponent == SystemComponents.Mobile &&
      (this.utility.isSelectedAreasForMobileLimited === true ||
        this.utility.isSelectedAreasForMobileLimited === null ||
        this.utility.isSelectedAreasForMobileLimited === undefined
      )
    ) {
      this.toastr.info(
        `A field operator can only be assigned to a maximum of ${maxSelectedDistricts} districts.`
      );
      (e.target as HTMLInputElement).checked = false;
    } else {
      this.subGeographicalRegionIds = this.subGeographicalRegionOptions.map(function (a) {
        return a.id;
      });
    }
  }
  deSelectAllRegions() {
    this.regionIds = [];
    this.syncAreasWithRegions();
  }
  deSelectAllGeographicalRegions() {
    this.geographicalRegionIds = [];
    this.syncSubGeographicalRegionsWithGeographicalRegions();
  }
  selectAllRegions() {
    this.regionIds = this.regionOptions.map(function (a) {
      return a.key;
    });
    this.syncAreasWithRegions();
  }
  selectAllGeographicalRegions() {
    this.geographicalRegionIds = this.geographicalRegionOptions?.map(function (a) {
      return a.id;
    });
    this.syncSubGeographicalRegionsWithGeographicalRegions();
  }
  deSelectAllAreas() {
    this.areaIds = [];
  }
  deSelectAllSubgeographicalRegions() {
    this.subGeographicalRegionIds = [];
  }
  checkRegion(val: number) {
    if (this.regionIds.includes(val))
      this.regionIds = this.regionIds.filter((item) => item != val);
    else this.regionIds.push(val);
    this.syncAreasWithRegions();
  }
  checkGeographicalRegion(val: number | null) {
    if (this.geographicalRegionIds?.includes(val))
      this.geographicalRegionIds = this.geographicalRegionIds.filter((item) => item != val);
    else this.geographicalRegionIds?.push(val);
    this.syncSubGeographicalRegionsWithGeographicalRegions();
  }
  isChecked(val: number): boolean {
    return this.regionIds?.includes(val);
  }
  isGeographicalChecked(val: number | null): boolean {
    return this.geographicalRegionIds!.includes(val);
  }
  onSetStatusOrganizationTeam(id: number, status: string) {
    var obj: any = { Id: id, Status: status };
    this.organizationTeamService.setStatus(obj).subscribe(
      (response) => {
        if (response.status == 'OK') {
          this.toastr.success('Success');
          this.reloadTable();
        } else this.toastr.error(response.message);
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  getAllTabsCount() {
    this.organizationTeamService.getTabsCount().subscribe(
      (response) => {
        if (response.status == 'OK') {
          this.countOrgTeam = response.data.organizationCount;
          this.countUserMgm = response.data.userManagementCount;
        } else this.toastr.error(response.message);
      },
      () => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  saveNewOrgTeam() {
    if (this.selectedOperationAccessLevel === -1) {
      this.toastr.warning("Operations Access Level must be selected.")
      return;
    }

    var obj: any = { id: this.id, name: this.newOrgTeamName, organizationTeamId: this.newOrgTeamId, organizationAccess: this.selectedOperationAccessLevel, paymentHubVendorId: this.paymentHubVendorId };
    this.organizationTeamService.saveOrganizationTeam(obj).subscribe(
      (response) => {
        if (response.status == 'OK') {
          this.closeModal?.nativeElement?.click();
          this.toastr.success('Success');
          this.reloadTable();
        } else {
          this.toastr.error(response.message);
        }
      },
      () => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  applySearchFilter(value: any) {
    this.filteredDts = this.dtOptions.filter((dt: { value: string | any }) =>
      dt.value.includes(value)
    );
  }
  applyCimSearchFilter(value: any) {
    this.filteredCimDts = this.cimDtOptions.filter((dt: { name: string | any }) =>
      dt.name.includes(value)
    );
  }
  editOrganizationTeam(obj: any) {
    this.isEdit = true;
    this.id = obj.id;
    this.newOrgTeamName = obj.name;
    this.newOrgTeamId = obj.organizationTeamId;
    this.selectedOperationAccessLevel =
      (obj.organizationAccess !== undefined && obj.organization !== null)
        ? OrganizationAccess[obj.organizationAccess as keyof typeof OrganizationAccess]
        : -1;
    this.paymentHubVendorId = (obj.paymentHubVendorId !== undefined && obj.paymentHubVendorId !== null) ? obj.paymentHubVendorId : null;
  }

  addOrganizationTeam() {
    this.isEdit = false;
    this.id = null;
    this.newOrgTeamName = '';
    this.newOrgTeamId = '';
    this.selectedOperationAccessLevel = -1;
    this.paymentHubVendorId = null;
  }

  download() {
    const dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: {
        searchParam: this.searchText,
        status: this.filterByValue,
        organizationId: this.filterByOrganizationId,
        roleIds: this.filterByRoles,
        regionIds: this.selectedFilterRegionIds,
        selectedAreas: this.selectedFilterAreaIds,
      },
    };

    this.userService.downloadUserManagementFile(dataIn).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 'OK' || data?.status === '200') {
          window.location.href = data.data;
        } else if (data?.status === 'Pending' || data?.status === '600') {
          this.toastr.info(data?.message || '');
        } else {
          this.toastr.error(data?.message || 'Request failed');
        }
      },
      error: (_) => this.toastr.error('Error occurred'),
    });
  }
}
